// src/Router/RequirePermRoute.jsx
import React from "react";
import PropTypes from "prop-types";
import { Navigate, useLocation } from "react-router-dom";
import { canSeeRoute } from "../utils/perm";
import { useSelector, shallowEqual } from "react-redux";

const hasToken = () =>
  !!(localStorage.getItem("authToken") || localStorage.getItem("token"));

export default function RequirePermRoute({ route, children }) {
  const location = useLocation();
  const user = useSelector((s) => s?.auth?.user, shallowEqual);

  // ✅ 1) If route has NO permission requirement, allow it
  if (!route?.meta?.perm) return children;

  // ✅ 2) If logged in but user/permissions not loaded yet, DON'T redirect to 404
  // (otherwise you will always hit 404 after login)
  if (hasToken() && !user) return children; // or return <div>Loading...</div>;

  const userPerms = user?.permissions || [];
  const isAdmin = user?.role === "admin" || userPerms.includes("*");

  if (canSeeRoute(userPerms, route, { isAdmin })) return children;

  return <Navigate to="/error-404" state={{ from: location }} replace />;
}

RequirePermRoute.propTypes = {
  route: PropTypes.shape({
    path: PropTypes.string,
    meta: PropTypes.shape({
      perm: PropTypes.string,
      action: PropTypes.oneOf(["read", "write"]),
    }),
  }).isRequired,
  children: PropTypes.node.isRequired,
};
